<template>
    <section id="clue-detail">
        <p
            class="
                is-size-5
                has-text-centered has-text-weight-bold
                is-uppercase
                pt-1
                mb-0
                pb-2
                has-background-very-light-pink
            "
        >
            {{ $t('Sessions.clue_detail_data') }}
        </p>

        <hr class="navbar-divider has-background-grey-lighter mt-0" />

        <table class="table is-fullwidth is-narrow is-vcentered">
            <thead>
                <tr>
                    <th class="has-text-centered pb-2 pt-0">
                        {{ $t('Sessions.total_clues_number') }}
                    </th>
                    <th class="has-text-centered pb-2 pt-0">
                        {{ $t('Sessions.total_points') }}
                    </th>
                    <th class="has-text-centered pb-2 pt-0">
                        {{ $t('Sessions.helpers_used') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="has-text-centered">
                        {{ player.clues.length }}
                    </td>
                    <td class="has-text-centered">
                        {{ totalCluePoints }}
                    </td>
                    <td>
                        <table class="table is-fullwidth is-narrow">
                            <tbody>
                                <tr>
                                    <td>{{ $t('Sessions.compass_aid') }}:</td>
                                    <td>
                                        {{ assistance.compass }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('Sessions.distance_aid') }}:</td>
                                    <td>
                                        {{ assistance.distance }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('Sessions.all_aids') }}:</td>
                                    <td>
                                        {{ assistance.all }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('Sessions.not_aids') }}:</td>
                                    <td>
                                        {{ assistance.nothing }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
            </tbody>
        </table>

        <hr class="navbar-divider has-background-grey-lighter mb-0" />

        <table
            class="
                table
                is-fullwidth is-narrow is-vcentered
                clue-detail-table
                mb-4
            "
        >
            <thead>
                <tr>
                    <th class="has-text-centered pb-2">
                        {{ $t('Sessions.clue') }}
                    </th>
                    <th class="has-text-centered pb-2">
                        {{ $t('Sessions.time_spent') }}
                    </th>
                    <th class="has-text-centered pb-2">
                        {{ $t('Sessions.helpers_title') }}
                    </th>
                    <th class="has-text-centered pb-2">
                        {{ $t('Sessions.points_obtained') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="clue in player.clues"
                    :key="clue._id"
                    class="is-bordered-bottom"
                >
                    <td class="is-fixed-width pb-2">
                        {{ clue.description | strippedContent }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ clue.scores[0].time | timeSpent }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ clueAssistance(clue.scores[0]) }}
                    </td>
                    <td class="has-text-centered pb-2">
                        {{ clue.scores[0].points }}
                    </td>
                </tr>
            </tbody>
        </table>
        <hr class="navbar-divider has-background-grey-lighter mt-0 mb-0" />
    </section>
</template>

<script>
import _ from 'underscore';
import { timeFormat } from '@/lib/helpers';

export default {
    name: 'SessionDetailPlayerClues',
    props: {
        player: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    filters: {
        timeSpent(time) {
            return timeFormat(+time) + ' min';
        },
        strippedContent: function (string) {
            const div = document.createElement('div');
            div.innerHTML = string;
            const text = div.textContent || div.innerText || '';
            return text;
        },
    },
    computed: {
        assistance() {
            let assistance = {
                compass: 0,
                distance: 0,
                nothing: 0,
                all: 0,
            };
            for (let clue of this.player.clues) {
                // console.log(clue);
                for (const score of clue.scores) {
                    if (score.assistance) {
                        // console.log('assistance found', score.assistance);
                        if (
                            score.owner.owner ==
                            this.$store.getters.personalData.owner
                        ) {
                            if (score.assistance.compass) {
                                // console.log('compass found', score.assistance);
                                assistance.compass = assistance.compass + 1;
                            }
                            if (score.assistance.distance) {
                                assistance.distance = assistance.distance + 1;
                            }
                            if (
                                score.assistance.compass &&
                                score.assistance.distance
                            ) {
                                assistance.all = assistance.all + 1;
                            }
                            if (
                                !score.assistance.compass &&
                                !score.assistance.distance
                            ) {
                                assistance.nothing = assistance.nothing + 1;
                            }
                        }
                    } else {
                        assistance.nothing = assistance.nothing + 1;
                    }
                }
            }
            return assistance;
        },
        totalCluePoints() {
            let points = 0;
            for (let clue of this.player.clues) {
                for (const score of clue.scores) {
                    points = points + score.points;
                }
            }
            // console.log('points', points);
            return points;
        },
        totalQuestionPoints() {
            let points = 0;
            for (let question of this.player.questions) {
                let userAnwer = _.findWhere(question.scores, {
                    profile: this.player._id,
                });
                points = points + userAnwer.points;
            }
            // console.log('points', points);
            return points;
        },
    },
    methods: {
        clueAssistance(clueData) {
            if (!clueData.assistance) {
                return this.$t('Sessions.helpers.nothing');
            } else {
                if (
                    clueData.assistance.compass &&
                    clueData.assistance.distance
                ) {
                    return this.$t('Sessions.helperswith_compass_and_distance');
                } else if (clueData.assistance.compass) {
                    return this.$t('Sessions.helperswith_compass');
                } else if (clueData.assistance.distance) {
                    return this.$t('Sessions.helperswith_distance');
                } else {
                    return this.$t('Sessions.helpersnothing');
                }
            }
        },
    },
};
</script>

<style scoped>
.table tr:not(.is-bordered-bottom) {
    border: none;
}
.content table td {
    border: none;
}

.content .table.is-vcentered td {
    vertical-align: middle;
}

.clue-detail-table tr:last-child {
    border-bottom: none;
}
</style>
